import retrieveLocalData from "./retrieveLocalData";

export default (destinationId) => {
  const destinationOrderCustomer = {
    ...retrieveLocalData("destinationOrderCustomer")
  };
  return destinationOrderCustomer[destinationId];
}